module.exports = __webpack_public_path__ + "img/20220107_103746 (1).d45c1c0d.jpg";